import { t } from 'i18next'
import i18n from '@/application/i18n/config'

export const translateCountryCode = (countryCode?: string): string => {
  if (!countryCode) {
    return t('common.empty')
  }
  const displayNames = new Intl.DisplayNames([i18n.language], { type: 'region' })
  return displayNames.of(countryCode) ?? countryCode
}
